module.exports = __webpack_public_path__ + "static/media/a50.29899194.jpg";